<template>
    <div class="left-side-navigation">
        <ul class="left-nav-menu">
            <li>
                <router-link to="/" exact-active-class="active">
                    <IconHome :width="14" :height="16" fill="#007BDF" />
                    <span>{{ t('home') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/report" exact-active-class="active">
                    <IconReport :width="14" :height="14" fill="#BFBFBF" />
                    <span>{{ t('report') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/settings" exact-active-class="active">
                    <IconSettings :width="14" :height="15" fill="black" />
                    <span>{{ t('settings') }}</span>
                </router-link>
            </li>
        </ul>
        <router-link to="#" class="logout-link" @click.prevent="logout">
            <IconLogout :width="16" :height="15" stroke="black" :stroke-width="1.5" />
            <span>{{ t('logout') }}</span>
        </router-link>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import { useOrderStore } from '@/stores/order';
import IconHome from '@/components/icons/iconHome.vue';
import IconReport from '@/components/icons/iconReport.vue';
import IconSettings from '@/components/icons/iconSettings.vue';
import IconLogout from '@/components/icons/iconLogout.vue';

const { t } = useI18n();
const router = useRouter();
const { clearAuthData } = useAuthStore();

const logout = () => {
    clearData();
    router.push('/login');
};

const clearData = () => {
    clearAuthData();
    localStorage.removeItem("order");
    useOrderStore().$reset();
}
</script>

<style scoped>
.logout-link {
    text-align: center;
}
</style>